import LocationOffIcon from '@mui/icons-material/LocationOff';
import { FormattedMessage } from 'react-intl';

import { OfferAvailabilityLabel } from './offer-availability.component';
import { messages } from './offer-availability.messages';

export const CouldBeUnavailableNearby = () => {
  return (
    <OfferAvailabilityLabel icon={LocationOffIcon}>
      <FormattedMessage {...messages['offer-availability:could-be-unavailable-nearby']} />
    </OfferAvailabilityLabel>
  );
};
